const NAME = "QUERIES";

export default NAME;